import React from 'react'
import { ErrorReference } from './error-reference'
import { reportClientError } from './client-reporter'

// The words of the crash page.
export const CRASH_TITLE = 'Something went wrong on this page.'
export const CRASH_HINT = 'We have been told about it. Reload the page to carry on; if it keeps happening, contact support.'

// What a person sees when the page crashed: the error is reported
// (client-reporter.js) and its report's id is shown as the reference for
// support, in the same words and shape as every API error's reference
// (ErrorReference), once content has answered.
export const CrashFallback = ({ reference, at }) => (
  <div className="container py-5" role="alert" data-testid="crash-fallback">
    <h1 className="h4">{CRASH_TITLE}</h1>
    <p className="text-body-secondary">{CRASH_HINT}</p>
    <div className="d-flex gap-2">
      <button type="button" className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>Reload the page</button>
      <a className="btn btn-outline-secondary btn-sm" href="/">Go to the home page</a>
    </div>
    {reference && <ErrorReference requestID={reference} at={at} />}
  </div>
)

// The admin's top-level error boundary (index.js): a render crash anywhere
// shows CrashFallback instead of a blank page, and is reported once with
// React's component stack.
export class ClientErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, reference: null, at: null }
  }

  static getDerivedStateFromError(error) {
    return { error: error || new Error('render failed') }
  }

  componentDidMount() { this.mounted = true }

  componentWillUnmount() { this.mounted = false }

  componentDidCatch(error, info) {
    const at = new Date().toISOString()
    reportClientError(error, { componentStack: info && info.componentStack }).then(reference => {
      if (reference && this.mounted) this.setState({ reference, at })
    })
  }

  render() {
    if (this.state.error) return <CrashFallback reference={this.state.reference} at={this.state.at} />
    return this.props.children
  }
}
